/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isNodeSchema(data) {
  return data && data.componentName;
}